import React from 'react';

import Typography from 'kingpin/atoms/Typography';
import ListItemWrapper from '../../../DatasetDefinitions/ListItemWrapper';
import Column from '../../../DatasetDefinitions/Column';
import Card from '../../../../../components/Common/Card';
import FindAndReplaceCheckbox from '../../MetricContextMenu/FindAndReplace/FindAndReplaceCheckbox';

const ChartDefinitionUsage = ({
  chartDefinitions,
  usedId,
}: {
  chartDefinitions: VisualisationDefinition[];
  usedId: string;
}) => {
  return (
    <>
      {chartDefinitions.length > 0 && (
        <div style={{ marginBottom: 24 }}>
          <div style={{ marginBottom: '8px' }}>
            <Typography.Header type="H5">
              {`Chart Definitions (${chartDefinitions.length})`}
            </Typography.Header>
          </div>

          <Card>
            {chartDefinitions.map((cd, index) => (
              <ListItemWrapper
                key={`${cd.id}-${usedId}`}
                isLast={chartDefinitions.length - 1 === index}
              >
                <FindAndReplaceCheckbox
                  item={{
                    type: 'chartDefinitions',
                    chartDefinition: cd,
                    itemId: cd.id,
                  }}
                />
                <Column
                  style={{
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    justifyContent: 'center',
                  }}
                >
                  <Typography.Body type="Body 12" color="var(--color-info-v2)">
                    {cd.name}
                  </Typography.Body>
                </Column>
              </ListItemWrapper>
            ))}
          </Card>
        </div>
      )}
    </>
  );
};

export default ChartDefinitionUsage;
